var _desc, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Binocular--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Binocular Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M0.75 18c0 0.5909 0.116396 1.1761 0.34254 1.7221 0.22615 0.5459 0.55762 1.042 0.97548 1.4599 0.41786 0.4178 0.91394 0.7493 1.4599 0.9755 0.54597 0.2261 1.13113 0.3425 1.72208 0.3425 0.59095 0 1.17611 -0.1164 1.72208 -0.3425 0.54596 -0.2262 1.04204 -0.5577 1.4599 -0.9755 0.41786 -0.4179 0.74933 -0.914 0.97548 -1.4599C9.6336 19.1761 9.75 18.5909 9.75 18s-0.1164 -1.1761 -0.34254 -1.7221c-0.22615 -0.5459 -0.55762 -1.042 -0.97548 -1.4599 -0.41786 -0.4178 -0.91394 -0.7493 -1.4599 -0.9755C6.42611 13.6164 5.84095 13.5 5.25 13.5c-0.59095 0 -1.17611 0.1164 -1.72208 0.3425 -0.54596 0.2262 -1.04204 0.5577 -1.4599 0.9755 -0.41786 0.4179 -0.74933 0.914 -0.97548 1.4599C0.866396 16.8239 0.75 17.4091 0.75 18Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.75001 18.0001V4.12505c0.00093 -0.63568 -0.22885 -1.2501 -0.64667 -1.72918 -0.41781 -0.47908 -0.99528 -0.79027 -1.62518 -0.87579 -0.62991 -0.08551 -1.26944 0.06045 -1.79987 0.41079 -0.53042 0.35035 -0.91569 0.88127 -1.08428 1.49418L0.911011 16.8051",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 18c0 0.5909 0.1164 1.1761 0.3425 1.7221 0.2262 0.5459 0.5577 1.042 0.9755 1.4599 0.4179 0.4178 0.914 0.7493 1.4599 0.9755 0.546 0.2261 1.1312 0.3425 1.7221 0.3425s1.1761 -0.1164 1.7221 -0.3425c0.5459 -0.2262 1.042 -0.5577 1.4599 -0.9755 0.4178 -0.4179 0.7493 -0.914 0.9755 -1.4599 0.2261 -0.546 0.3425 -1.1312 0.3425 -1.7221s-0.1164 -1.1761 -0.3425 -1.7221c-0.2262 -0.5459 -0.5577 -1.042 -0.9755 -1.4599 -0.4179 -0.4178 -0.914 -0.7493 -1.4599 -0.9755 -0.546 -0.2261 -1.1312 -0.3425 -1.7221 -0.3425s-1.1761 0.1164 -1.7221 0.3425c-0.5459 0.2262 -1.042 0.5577 -1.4599 0.9755 -0.4178 0.4179 -0.7493 0.914 -0.9755 1.4599 -0.2261 0.546 -0.3425 1.1312 -0.3425 1.7221Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 18.0001V4.12505c-0.0009 -0.63568 0.2289 -1.2501 0.6467 -1.72918 0.4178 -0.47908 0.9953 -0.79027 1.6252 -0.87579 0.6299 -0.08551 1.2694 0.06045 1.7998 0.41079 0.5304 0.35035 0.9157 0.88127 1.0843 1.49418l3.683 13.37705",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.75 9h4.5v3h-4.5V9Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReach);
export default __webpack_public_path__ + "static/media/reach.d9d325f8e032e6a27b292bae2cab85b0.svg";
export { ForwardRef as ReactComponent };